import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {FilterUtil} from "../../../util/filter.util";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {VerifyOptions} from "../../dialog/verify/options/verify.options";
import {VerifyComponent} from "../../dialog/verify/verify.component";
import {DataResponse} from "../../../network/service/data.response";
import {AddOrUpdateAttributeOptions} from "../dialog/add-or-update-attribute/options/add-or-update-attribute.options";
import {AddOrUpdateAttributeComponent} from "../dialog/add-or-update-attribute/add-or-update-attribute.component";

@Component({
  selector: 'app-attributes',
  standalone: false,
  templateUrl: './attributes.component.html',
  styleUrls: ['./attributes.component.scss']
})
export class AttributesComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'Title', 'Code', 'Order', 'AttributeType'];
  displayDataSources = ['edit', 'delete', 'AttributeTitle', 'AttributeCode', 'AttributeOrder', 'AttributeType.Title'];
  displayColumnTypes = ['event', 'event', 'string', 'string', 'number', 'string'];
  displayEndPoint = [this.ServicePath.UPDATE_ATTRIBUTE, this.ServicePath.DELETE_ATTRIBUTE, '', '', '', ''];
  attributes: any = [];
  allFilters = FilterUtil.AttributesFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getAttribute(this.tableProperties.offset, this.tableProperties.limit, 'AttributeType', undefined, {
      Filter: this.filters,
      Order: this.tableProperties.order ?? {
        Field: 'ModifyDate',
        Type: 'DESC'
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.attributes = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.attributes) {
      for (let i = 0; i < this.attributes.length; i++) {
        this.attributes[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.attributes[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    let addOrUpdateAttributeOptions = new AddOrUpdateAttributeOptions();
    addOrUpdateAttributeOptions.attribute = {};
    addOrUpdateAttributeOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateAttributeComponent = this.matDialog.open(AddOrUpdateAttributeComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateAttributeComponent.componentInstance.addOrUpdateAttributeOptions = addOrUpdateAttributeOptions;
  }

  onUpdateClicked(index: number) {
    let addOrUpdateAttributeOptions = new AddOrUpdateAttributeOptions();
    addOrUpdateAttributeOptions.attribute = this.attributes[index];
    addOrUpdateAttributeOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateAttributeComponent = this.matDialog.open(AddOrUpdateAttributeComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateAttributeComponent.componentInstance.addOrUpdateAttributeOptions = addOrUpdateAttributeOptions;
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteAttribute(this.attributes[index].AttributeId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }
}
